  export const placeFakeData=[
  {
    name:"COX'S BAZAR",
    desc:"Cox's Bazar isa city,fishing port,tourism centre and district headquarters in southeastern Bangladesh. It is famous mostly for it's long natural sandy beach and it..",
    lat:'21.4272',
    long:'92.0058',
    photoUrl:"https://i.ibb.co/b5ChS0Q/background.png" 

  },
  {
    name:"SREEMANGAL",
    desc:"It is said the name Sreemangal (or Srimangal) is named after Sri Das and Mangal Das; two brothers who settled on the banks of the Hail Haor.[2] A copper plate of Raja Marundanath from the 11th century was found in Kalapur. During an excavation ",
    lat:'24.3065',
    long:'91.7296',
    photoUrl:"https://i.ibb.co/r4V4r8p/Sreemongol.png"
  },
  {
    name:"SUNDARBAN",
    desc:"The Sundarbans is a mangrove area in the delta formed by the confluence of the Ganges, Brahmaputra and Meghna Rivers in the Bay of Bengal. It spans from the Hooghly River in India's state of West Bengal to the Baleswar River in Bangladesh. It comprises",
    lat:'21.9497',
    long:'89.1833',
    photoUrl:"https://i.ibb.co/3TPDzGv/sundorbon.png"

  }

]